<template>
<div class="container-fluid">
    <module-edit-sme
    :module_view_edit="true"
    :module_view_language="module_languages"
    :current_module_view_id="this.$route.params.id"

    >
        <div slot="module_view">
            <div v-if="current_module != null ">
            <generic-module-view 
                    ref="genericModuleView"
                    :generic_module_view="true"
                    :current_lesson="current_lesson"
                    :lessons="lessons"
                    :current_module="current_module"
                    :course_data="course_data"
                    :module_languages="module_languages"
                    :available_languages="languages_available"
                    @removeModalLanguage="removeModalLanguage"
                    @saveModule="saveModule"
                    @addModalLanguage="addModalLanguage"
                    @addLanguageModule="addLanguageModule"
                    @currentModuleBaseAdd="currentModuleBaseAdd"
                    @currentModuleQuizAdd="currentModuleQuizAdd"
                    @refreshModule="getModule"
                    >
                    <div slot="program-agency">

                <h6>Notes</h6>
                    <textarea class="form-control mb-2" 
                    v-model="current_module.notes"
                    placeholder="Module Notes"
                    v-validate="''"
                    name="notes"
                    ></textarea>
                    <hr>
                <program-agency-collapse :current_module="current_module"
                :organizationLength="organizationLength"
                ></program-agency-collapse>
            
                </div>
                <!-- <div slot="program-lesson">
                        <program-lesson-view 
                        v-on="$listeners"
                        :generic_module_view="true"
                        :current_lesson="current_lesson"
                        :lessons="lessons"
                        :wider_view="false"
                        @saveModule="saveModule"
                        ></program-lesson-view>
                </div> -->
            </generic-module-view>
             </div>

        </div>
    </module-edit-sme>
    </div>
</template>
<script>
import GenericModuleView from '../SharedViews/GenericModuleView'
import ProgramLessonView from '../SharedViews/ProgramLessonView'
import ProgramAgencyCollapse from '../SharedViews/ProgramAgencyCollapse'
import { EventBus } from './../../../event_bus.js';
import SMECourseEditComponent from "../courses/SMECourseEditComponent";
import MixinSME from '../MixinSME'
export default {
mixins: [MixinSME],
components: {
		GenericModuleView,
        ProgramLessonView,
        ProgramAgencyCollapse,
        'module-edit-sme':SMECourseEditComponent


},
data: function(){

    return{
        id:this.$route.params.id,
        current_module:null,
        course_data:{},
        current_lesson:{},
        lessons:[],
        module_to_delete:'',
        show_modal_delete_module:false,
        show_module_delete_lesson:false,
        modal_lesson:false,
        selected_language:null,
        module_languages:[],
        languages_all:[],
        languages_available:[],
        temp_lesson_title: 'Lesson created! Click me to edit'
    }
},
computed : {
    organizationLength: function(){
        if(this.current_module.organizations){
          return Object.keys(this.current_module.organizations).length

        }
    },
   
},
watch:{
    module_languages: function(val,oldval){
        //If module has languages we remove from language list
        for(let i in val){
            for(let z in this.languages_available){
                if(val[i].key == this.languages_available[z].code_2){
                    this.languages_available.splice(z,1)
                }
            }
        }
    }

},
created: function(){
    this.getModule();
},
mounted: function(){
    EventBus.$on('update_module', (module) =>{
        this.current_module = module
        this.available_languages();
    })
     EventBus.$on('selected_laguage_change', (language) => {
				this.selected_language = language
			});
     EventBus.$on('addLanguageModule', (language) => {
         this.module_languages.push({key:language.code_2, value:language.name})
				this.addLanguageModule(language)
                this.$forceUpdate(); 
			});
      EventBus.$on('update_program_lesson', (new_lesson) => {
            console.log("update program lesson ", new_lesson)
                 this.$nextTick(() => {
                     if(new_lesson.lessons.length >0 && this.current_module != null){
                          this.current_module.lessons  = this.checkLessonLanguages(this.selected_language,new_lesson.lessons)
                     }
                });
        })

},
methods:{
    getModule() {
        var params ={
            id: this.id,
            filters:{
                full:true,
                page_loading:true,
                exclude : ['lessons_modules','quiz_lesson'],
            }
        }

        this.$store.dispatch('getModule', params).then((res) => {
            console.log(res)
            if(res.data.data.name == null || res.data.data.name == ''){
                res.data.data.name = {}
            }
            if(res.data.data.description == null || res.data.data.description == ''){
                res.data.data.description = {}
            }
            if(res.data.data.image == null || res.data.data.image == ''){
                res.data.data.image = {}
            }
            this.current_module = res.data.data
            this.available_languages();
            this.nullChecker(res.data.data.lessons)
            this.nullChecker(res.data.data)
            this.lessons = res.data.data.lessons
        });
    },

    currentModuleQuizAdd: function(id){
        this.current_module.quiz_module_id = id
    },
    currentModuleBaseAdd: function(id){
        this.current_module.base_module_id = id
    },
     checkLessonLanguages: function(val,lesson_list){
            console.log("inside check lesson")
           for(let i in lesson_list){
            if(lesson_list[i].name == null){
                lesson_list[i].name = {}
            } 
            if(!lesson_list[i].name.hasOwnProperty(val.key)){
                lesson_list[i].name[val.key] = ''
            }
            if(lesson_list[i].image == null){
            console.log("inside image null")

                lesson_list[i].image = {}
            }
            if(lesson_list[i].tincan_url == null){
                lesson_list[i].tincan_url = {}
            }
            if(!lesson_list[i].image.hasOwnProperty(val.key)){
                lesson_list[i].image[val.key] = null
            }

           }
           return lesson_list
        },
    async available_languages() {
    var params = { available_in_system: 1 };

      this.$store.dispatch("getLanguages", params).then(res => {
        this.languages_all = res.data.data;
        let temp_less = [];
        for (let i in this.languages_all) {
            if (
            this.languages_all[i][0].available_in_system == 1
            ) {
            temp_less.push(this.languages_all[i][0]);
            }
        }
        this.languages_available = temp_less
        this.module_available_languages();
      });
      
    },
    async module_available_languages () {
      if (this.current_module == undefined) {
        return;
      }
      let keys = [];
      let full_language = [];
      keys.push(Object.keys(this.current_module.name));
      console.log(keys)
      for (let i in this.languages_available) {
        for (let k in keys[0]) {
          if (keys[0][k] == this.languages_available[i].code_2) {
            let temp = { key: keys[0][k], value: this.languages_available[i].name };
            full_language.push(temp);
          }
        }
      }
      this.module_languages = full_language

    },
  
    addLanguageModule:function(language){
        this.current_module.name[language.code_2] = '' //'New  '+ language.name + ' Name'
        
        this.current_module.description[language.code_2] ='';
                  //'New  '+language.name + ' Description'

    },
    nullChecker: function(item){
            let keys = Object.keys(item)
            if((keys != null || keys !='') && item != null){
                for(let i in keys){
                    if(item[keys[i]] == null ){
                        item[keys[i]] = ''
                    }
                }
            }
    },
    openModalLesson : function(){
        this.modal_lesson = true;

        this.getExistingLessons();
    },
    showModalDeleteModule : function(module){
        this.module_to_delete = module;
        this.show_modal_delete_module = true;
    },
    saveModule: function(){
        //Lesson Title Check
        for(let i in this.current_module.lessons){
            if(this.current_module.lessons[i].title == this.temp_lesson_title){
                if('EN' in this.current_module.lessons[i].name){
						this.current_module.lessons[i].title = this.current_module.lessons[i].name['EN']
					}
            }
        }

        console.log('edit module');
        this.$validator.validateAll().then((result) => {
            console.log('running this');
            if (result) {
                console.log('is good');
                this.$store.dispatch('editModule', this.current_module).catch((error) => {
                    this.$snotify.error('Error from server');
                });
            }
        });
    },

    //addCategory endpoint is no longer supported since Tags update. It has been replaced
    addCategoryModule(){
        var params = {
            id: this.current_module.id,
            category_id: this.current_module.sme_categories.map(elem => {return elem.id} )
        }
        this.$store.dispatch('editModuleCategory', params).then((res) => {

        }).catch((error) => {
            this.created();
            this.$snotify.error('Error from server');
        });
    }
}
}
</script>



// WEBPACK FOOTER //
// src/components/sme/modules/SMEModuleView.vue